import gql from 'graphql-tag'

import { LeadFieldsFragment } from './lead'

export const LEAD_BOOKMARK_MUTATION = gql`
  mutation LeadBookmark($schoolId: Int!) {
    lead: leadBookmark(schoolId: $schoolId) {
      ...LeadFields
    }
  }

  ${LeadFieldsFragment}
`
